import React, {useState, useEffect, Fragment} from 'react'

import withApiService from '../hoc/with-api-service'
import withData from '../hoc/with-data'

import FeaturedSlider from './featured-slider'
import FeaturedMenu from './featured-menu'

const Featured = ({response}) => {
  const
    [data, setData] = useState([]),
    [currentCategoryId, setCurrentCategoryId] = useState('all'),
    [currentCategoryData, setCurrentCategoryData] = useState([]);

  useEffect(() => {
    const {data} = response;

    if (data) {
      setData(data);
      setCurrentCategoryData(data)
    }
  }, [response]);


  const handleMenuClick = event => {
    event.preventDefault();

    const newCurrentCategoryId = event.target.dataset.id;

    const newCurrentCategoryData = newCurrentCategoryId !== 'all' ?
      data.filter(item => `${item.categoryId}` === newCurrentCategoryId) :
      data;

    setCurrentCategoryId(newCurrentCategoryId);
    setCurrentCategoryData(newCurrentCategoryData)
  };

  return data.length > 0 ?
    (<Fragment>
      <FeaturedMenu currentCategoryId={currentCategoryId}
                    handleMenuClick={handleMenuClick}/>
      {currentCategoryData.length > 0 &&
      <FeaturedSlider countOfViewed={3}
                      sliderData={currentCategoryData}/>
      }
    </Fragment>) :
    (<div className="new-deals wave-bottom"/>)
};

const mapMethodsToProps = (apiService) => {
  return {
    getData: apiService.getFeatured
  };
};

export default withApiService(mapMethodsToProps)(withData(Featured))
